"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combineValidators = combineValidators;
// Composes a single validator function from an array of validators
function combineValidators(validators) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return validators.reduce(function (error, validator) {
      return error || validator.apply(null, args);
    }, undefined);
  };
}
//# sourceMappingURL=combineValidators.js.map